import { Component, Inject, OnInit } from '@angular/core';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  BrnOverlayService,
  BRN_OVERLAY_DATA,
} from 'projects/brn-frontend/src/app/core/services/brn-overlay.service';
import { Client } from 'projects/brn-frontend/src/app/features/bot/modules/bot-crm/store';
import { ChatSelectors, SetClient } from '../../store';

@Component({
  selector: 'brn-channels-popup',
  templateUrl: './channels-popup.component.html',
  styleUrls: ['./channels-popup.component.scss'],
})
export class ChannelsPopupComponent implements OnInit {
  @ViewSelectSnapshot(ChatSelectors.client)
  currentClient!: Client;

  constructor(
    @Inject(BRN_OVERLAY_DATA) public clients: any,
    private overlayService: BrnOverlayService,
    private store: Store
  ) {}

  ngOnInit(): void {}

  switchClient(client: Client): void {
    this.overlayService.close();
    this.store.dispatch(new SetClient(client));
  }

  channelIcon(provider: string): string {
    return `assets/images/socials/icons/${provider}.png`;
  }

  activeClient(client: Client): boolean {
    return this.currentClient.provider === client.provider;
  }
}
